module.exports = __webpack_public_path__ + "img/img_sub_prod_brityassistant02.4a05f499.svg";